import { AppShell, Button, Nav, NavItem, Toaster } from '@1k5-tech-es/grado-react';
import { ThemeToggle } from '@1k5-tech-es/grado-react/labs';
import { useQuery } from '@tanstack/react-query';
import { FileText, KeyRound, LogOut, Table2, Users, UsersRound } from 'lucide-react';
import { NavLink, Outlet } from 'react-router';

import { api } from '../api/client';
import type { AppUserRow } from '../api/types';
import { useAuth } from '../auth/AuthProvider';

/** Administrators see how many access requests are waiting. */
function usePendingRequests(isAdmin: boolean): number {
  const users = useQuery({
    queryKey: ['users'],
    queryFn: () => api.get<{ users: AppUserRow[] }>('/api/users').then((r) => r.users),
    enabled: isAdmin,
    refetchInterval: 60_000,
  });
  return users.data?.filter((u) => u.access === 'pending').length ?? 0;
}

export function Layout() {
  const { session, logout } = useAuth();
  const { user } = session;
  const pending = usePendingRequests(user.isAdmin);

  return (
    <AppShell
      product="Rendimiento de asesores"
      sidebar={
        <Nav>
          <NavItem as={NavLink} to="/datos" label="Datos mensuales" icon={Table2} />
          <NavItem as={NavLink} to="/informes" label="Informes" icon={FileText} />
          <NavItem as={NavLink} to="/asesores" label="Asesores" icon={Users} />
          <NavItem as={NavLink} to="/equipos" label="Equipos" icon={UsersRound} />
          {user.isAdmin && (
            <NavItem
              as={NavLink}
              to="/usuarios"
              label="Usuarios"
              icon={KeyRound}
              badge={pending > 0 ? pending : undefined}
              aria-label={pending > 0 ? `Usuarios, ${pending} solicitudes pendientes` : undefined}
            />
          )}
        </Nav>
      }
      sidebarFooter={
        <div className="grid gap-3">
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold">{user.name ?? user.email}</p>
            <p className="truncate text-xs text-muted-foreground">{user.email}</p>
          </div>
          <ThemeToggle defaultMode="light" />
          <Button variant="ghost" size="sm" icon={LogOut} onClick={() => void logout()} className="justify-start">
            Cerrar sesión
          </Button>
        </div>
      }
    >
      <div className="px-4 py-6 md:px-8">
        <Outlet />
      </div>
      <Toaster />
    </AppShell>
  );
}
